import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Disposable } from '../../../../base/common/lifecycle.js';
import { Emitter } from '../../../../base/common/event.js';
import * as platform from '../../../../base/common/platform.js';

function hasModifier(e, modifier) {
  return !!e[modifier];
}
/**
 * An event that encapsulates the various trigger modifiers logic needed for go to definition.
 */


export var ClickLinkMouseEvent = function ClickLinkMouseEvent(source, opts) {
  _classCallCheck(this, ClickLinkMouseEvent);

  this.target = source.target;
  this.hasTriggerModifier = hasModifier(source.event, opts.triggerModifier);
  this.hasSideBySideModifier = hasModifier(source.event, opts.triggerSideBySideModifier);
  this.isNoneOrSingleMouseDown = source.event.detail <= 1;
};
/**
 * An event that encapsulates the various trigger modifiers logic needed for go to definition.
 */

export var ClickLinkKeyboardEvent = function ClickLinkKeyboardEvent(source, opts) {
  _classCallCheck(this, ClickLinkKeyboardEvent);

  this.keyCodeIsTriggerKey = source.keyCode === opts.triggerKey;
  this.keyCodeIsSideBySideKey = source.keyCode === opts.triggerSideBySideKey;
  this.hasTriggerModifier = hasModifier(source, opts.triggerModifier);
};
export var ClickLinkOptions = /*#__PURE__*/function () {
  function ClickLinkOptions(triggerKey, triggerModifier, triggerSideBySideKey, triggerSideBySideModifier) {
    _classCallCheck(this, ClickLinkOptions);

    this.triggerKey = triggerKey;
    this.triggerModifier = triggerModifier;
    this.triggerSideBySideKey = triggerSideBySideKey;
    this.triggerSideBySideModifier = triggerSideBySideModifier;
  }

  _createClass(ClickLinkOptions, [{
    key: "equals",
    value: function equals(other) {
      return this.triggerKey === other.triggerKey && this.triggerModifier === other.triggerModifier && this.triggerSideBySideKey === other.triggerSideBySideKey && this.triggerSideBySideModifier === other.triggerSideBySideModifier;
    }
  }]);

  return ClickLinkOptions;
}();

function createOptions(multiCursorModifier) {
  if (multiCursorModifier === 'altKey') {
    if (platform.isMacintosh) {
      return new ClickLinkOptions(57
      /* Meta */
      , 'metaKey', 6
      /* Alt */
      , 'altKey');
    }

    return new ClickLinkOptions(5
    /* Ctrl */
    , 'ctrlKey', 6
    /* Alt */
    , 'altKey');
  }

  if (platform.isMacintosh) {
    return new ClickLinkOptions(6
    /* Alt */
    , 'altKey', 57
    /* Meta */
    , 'metaKey');
  }

  return new ClickLinkOptions(6
  /* Alt */
  , 'altKey', 5
  /* Ctrl */
  , 'ctrlKey');
}

export var ClickLinkGesture = /*#__PURE__*/function (_Disposable) {
  _inherits(ClickLinkGesture, _Disposable);

  var _super = _createSuper(ClickLinkGesture);

  function ClickLinkGesture(editor) {
    var _this;

    _classCallCheck(this, ClickLinkGesture);

    _this = _super.call(this);
    _this._onMouseMoveOrRelevantKeyDown = _this._register(new Emitter());
    _this.onMouseMoveOrRelevantKeyDown = _this._onMouseMoveOrRelevantKeyDown.event;
    _this._onExecute = _this._register(new Emitter());
    _this.onExecute = _this._onExecute.event;
    _this._onCancel = _this._register(new Emitter());
    _this.onCancel = _this._onCancel.event;
    _this._editor = editor;
    _this._opts = createOptions(_this._editor.getOption(61
    /* multiCursorModifier */
    ));
    _this._lastMouseMoveEvent = null;
    _this._hasTriggerKeyOnMouseDown = false;
    _this._lineNumberOnMouseDown = 0;

    _this._register(_this._editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(61
      /* multiCursorModifier */
      )) {
        var newOpts = createOptions(_this._editor.getOption(61
        /* multiCursorModifier */
        ));

        if (_this._opts.equals(newOpts)) {
          return;
        }

        _this._opts = newOpts;
        _this._lastMouseMoveEvent = null;
        _this._hasTriggerKeyOnMouseDown = false;
        _this._lineNumberOnMouseDown = 0;

        _this._onCancel.fire();
      }
    }));

    _this._register(_this._editor.onMouseMove(function (e) {
      return _this._onEditorMouseMove(new ClickLinkMouseEvent(e, _this._opts));
    }));

    _this._register(_this._editor.onMouseDown(function (e) {
      return _this._onEditorMouseDown(new ClickLinkMouseEvent(e, _this._opts));
    }));

    _this._register(_this._editor.onMouseUp(function (e) {
      return _this._onEditorMouseUp(new ClickLinkMouseEvent(e, _this._opts));
    }));

    _this._register(_this._editor.onKeyDown(function (e) {
      return _this._onEditorKeyDown(new ClickLinkKeyboardEvent(e, _this._opts));
    }));

    _this._register(_this._editor.onKeyUp(function (e) {
      return _this._onEditorKeyUp(new ClickLinkKeyboardEvent(e, _this._opts));
    }));

    _this._register(_this._editor.onMouseDrag(function () {
      return _this._resetHandler();
    }));

    _this._register(_this._editor.onDidChangeCursorSelection(function (e) {
      return _this._onDidChangeCursorSelection(e);
    }));

    _this._register(_this._editor.onDidChangeModel(function (e) {
      return _this._resetHandler();
    }));

    _this._register(_this._editor.onDidChangeModelContent(function () {
      return _this._resetHandler();
    }));

    _this._register(_this._editor.onDidScrollChange(function (e) {
      if (e.scrollTopChanged || e.scrollLeftChanged) {
        _this._resetHandler();
      }
    }));

    return _this;
  }

  _createClass(ClickLinkGesture, [{
    key: "_onDidChangeCursorSelection",
    value: function _onDidChangeCursorSelection(e) {
      if (e.selection && e.selection.startColumn !== e.selection.endColumn) {
        this._resetHandler(); // immediately stop this feature if the user starts to select (https://github.com/Microsoft/vscode/issues/7827)

      }
    }
  }, {
    key: "_onEditorMouseMove",
    value: function _onEditorMouseMove(mouseEvent) {
      this._lastMouseMoveEvent = mouseEvent;

      this._onMouseMoveOrRelevantKeyDown.fire([mouseEvent, null]);
    }
  }, {
    key: "_onEditorMouseDown",
    value: function _onEditorMouseDown(mouseEvent) {
      // We need to record if we had the trigger key on mouse down because someone might select something in the editor
      // holding the mouse down and then while mouse is down start to press Ctrl/Cmd to start a copy operation and then
      // release the mouse button without wanting to do the navigation.
      // With this flag we prevent goto definition if the mouse was down before the trigger key was pressed.
      this._hasTriggerKeyOnMouseDown = mouseEvent.hasTriggerModifier;
      this._lineNumberOnMouseDown = mouseEvent.target.position ? mouseEvent.target.position.lineNumber : 0;
    }
  }, {
    key: "_onEditorMouseUp",
    value: function _onEditorMouseUp(mouseEvent) {
      var currentLineNumber = mouseEvent.target.position ? mouseEvent.target.position.lineNumber : 0;

      if (this._hasTriggerKeyOnMouseDown && this._lineNumberOnMouseDown && this._lineNumberOnMouseDown === currentLineNumber) {
        this._onExecute.fire(mouseEvent);
      }
    }
  }, {
    key: "_onEditorKeyDown",
    value: function _onEditorKeyDown(e) {
      if (this._lastMouseMoveEvent && (e.keyCodeIsTriggerKey // User just pressed Ctrl/Cmd (normal goto definition)
      || e.keyCodeIsSideBySideKey && e.hasTriggerModifier // User pressed Ctrl/Cmd+Alt (goto definition to the side)
      )) {
        this._onMouseMoveOrRelevantKeyDown.fire([this._lastMouseMoveEvent, e]);
      } else if (e.hasTriggerModifier) {
        this._onCancel.fire(); // remove decorations if user holds another key with ctrl/cmd to prevent accident goto declaration

      }
    }
  }, {
    key: "_onEditorKeyUp",
    value: function _onEditorKeyUp(e) {
      if (e.keyCodeIsTriggerKey) {
        this._onCancel.fire();
      }
    }
  }, {
    key: "_resetHandler",
    value: function _resetHandler() {
      this._lastMouseMoveEvent = null;
      this._hasTriggerKeyOnMouseDown = false;

      this._onCancel.fire();
    }
  }]);

  return ClickLinkGesture;
}(Disposable);